module.exports = __webpack_public_path__ + "img/rwap_02.134fb436.jpg";